<h2 mat-dialog-title>{{ data.title ?? "Information" }}</h2>
<mat-dialog-content>
  <p>
    {{ data.message ?? "Your request will be processed as soon as possible." }}
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>OK</button>
</mat-dialog-actions>
